import { render, staticRenderFns } from "./VehicleCard.vue?vue&type=template&id=28d92e2f"
import script from "./VehicleCard.vue?vue&type=script&lang=js"
export * from "./VehicleCard.vue?vue&type=script&lang=js"
import style0 from "./VehicleCard.vue?vue&type=style&index=0&id=28d92e2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports